import { Store } from '@ngrx/store';
import cloneDeep from 'lodash.clonedeep';
import { setSelectedFolderableOperation } from 'FoldersApp/state/selected-folder-item/selected-folderable-operation.action';
import { clearPageErrorMessage, setPageErrorMessage, } from 'NewAngular/features/components/page-error-message/state/page-error-message.action';
import { getScatterPlotFetchParams, hasValidRequestData, } from 'ChartApp/ts/apps/scatter-plot/state/scatter-plot.selectors';
import { SAVED_SCATTER_PLOT_SHARING_OPTIONS, SCATTER_PLOT_SHARING_URL_OPTIONS, } from 'ChartApp/ts/apps/scatter-plot/constants';
import { COPY_URL_LINK, EMBED, EMBED_TYPE_IMAGE_CODE, LEGACY_EXPORT_PROHIBITED, SHARE, TWEET, } from 'NewAngular/constants/core.constants';
import { ExportOption } from 'ChartApp/ts/services/export-service/enum';
import { SavedItemType } from 'NewAngular/features/components/saved-items/enums/saved-item-type.enum';
import { ScatterPlotAppStateManager } from 'ChartApp/ts/apps/scatter-plot/services/scatter-plot-app-state-manager.service';
import { SelectedScatterPlotService } from 'ChartApp/ts/apps/scatter-plot/services/selected-scatter-plot.service';
import { ExportService } from 'ChartApp/ts/services/export-service/export.service';
import { ScatterPlotService } from 'ChartApp/ts/services/scatter-plot.service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { FeatureNeededComponent } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.component';
import { ChartEmbedModalComponent } from 'NewAngular/features/components/modals/chart-embed-modal/chart-embed-modal.component';
import { UrlShortenerModalComponent } from 'NewAngular/features/components/modals/url-shortener-modal/url-shortener-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "ChartApp/ts/apps/scatter-plot/services/scatter-plot-app-state-manager.service";
import * as i2 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i3 from "ChartApp/ts/apps/scatter-plot/services/selected-scatter-plot.service";
import * as i4 from "ChartApp/ts/services/scatter-plot.service";
import * as i5 from "@ngrx/store";
import * as i6 from "@angular/common";
import * as i7 from "../../../../../../../../../ycharts/static/ts/features/components/modals/chart-embed-modal/chart-embed-modal.component";
import * as i8 from "../../../../../../../../entitlements/static/entitlements/ts/features/feature-needed/feature-needed.component";
import * as i9 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i10 from "../../../../../../../../../ycharts/static/ts/features/components/modals/sharing-modal/sharing-modal.component";
import * as i11 from "../../../../../../../../../ycharts/static/ts/features/components/dropdowns/simple-dropdown/simple-dropdown.component";
import * as i12 from "../../../../../../../../../ycharts/static/ts/features/components/modals/url-shortener-modal/url-shortener-modal.component";
import * as i13 from "ChartApp/ts/apps/scatter-plot/components/scatter-plot-saved-item-dropdown/scatter-plot-saved-item-dropdown.component";
const _c0 = ["featureNeededComponent"];
const _c1 = ["chartEmbedModalComponent"];
function ScatterPlotHeaderComponent_ycn_sharing_modal_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-sharing-modal", 12);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("publicSharingItemType", "scatter_plot")("shareableItem", ctx_r1.selectedItem);
} }
/**
 *
 * Scatter Plot Header Component
 *
 * This component is the header on the scatter plot page that allows users to save, open, export, share, reset, etc.
 *
 * Input Properties:
 *  securityPageType: security type for the page that this component is on, if any. Used with the itemType to determine which user preference field to save
 *                    the default state to.
 */
export class ScatterPlotHeaderComponent {
    constructor(scatterPlotAppStateManager, featureService, selectedScatterPlotService, scatterPlotService, store) {
        this.scatterPlotAppStateManager = scatterPlotAppStateManager;
        this.featureService = featureService;
        this.selectedScatterPlotService = selectedScatterPlotService;
        this.scatterPlotService = scatterPlotService;
        this.store = store;
        this.SAVED_SCATTER_PLOT_ITEM_TYPE = SavedItemType.SCATTER_PLOT;
        this.selectedFolderableInfo = null;
        this.selectedItem = null;
        // Sharing
        this.sharingOptions = SAVED_SCATTER_PLOT_SHARING_OPTIONS;
        // Exporting
        this.EXPORT_OPTIONS = {
            title: {
                label: 'Export',
                icon: 'icon-export',
            },
            list: [
                { type: 'option', label: 'Export Data', value: ExportOption.export, icon: 'icon-csv' },
                { type: 'option', label: 'Download Image', value: ExportOption.download, icon: 'icon-download' },
                { type: 'option', label: 'Print', value: ExportOption.print, icon: 'icon-print' },
            ],
        };
        this.chartHasValidExportData = false;
        this.mapStateToComponent = (state) => {
            this.scatterPlotDataParams = getScatterPlotFetchParams(state);
            this.selectedFolderableInfo = this.selectedScatterPlotService.getSelection();
            this.selectedItem = this.selectedFolderableInfo ? this.selectedFolderableInfo.item : null;
            const sharingOptions = cloneDeep(SAVED_SCATTER_PLOT_SHARING_OPTIONS);
            // Determine whether to enable the "Share with Team" option.
            sharingOptions.list[0].disabled = this.selectedItem ? !this.selectedItem.permissions.canShare : true;
            this.sharingOptions = sharingOptions;
            this.chartHasValidExportData = hasValidRequestData(state);
            this.scatterPlotDataParams.mode = EMBED_TYPE_IMAGE_CODE;
            this.scatterPlotState = state.scatterPlot;
            this.embedCodeUrl = this.chartHasValidExportData
                ? this.scatterPlotService.getChartEmbedUrl(this.scatterPlotDataParams)
                : null;
        };
        this.exportErrorHandler = (response) => {
            if (response.status === 403) {
                if (response.error === LEGACY_EXPORT_PROHIBITED) {
                    // Handle image export errors
                    this.setErrorMessage('Unable to generate scatter plot');
                }
                else {
                    // Handles errors when exporting CSV data which is returned as a Blob
                    response.error.text().then((text) => {
                        if (text === LEGACY_EXPORT_PROHIBITED) {
                            this.setErrorMessage(`Unable to generate scatter plot`);
                        }
                    });
                }
            }
            else {
                this.setErrorMessage('An error occurred while exporting the chart image. Please try again or contact support.');
            }
        };
        this.storeSubscription = this.store.select('reducers').subscribe(this.mapStateToComponent);
    }
    ngAfterViewInit() {
        this.exportService = new ExportService(this.scatterPlotService, this.featureService, this.featureNeededComponent, this.exportErrorHandler);
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    sharingHandler(selectedItem) {
        switch (selectedItem) {
            case COPY_URL_LINK:
                if (this.urlShortenerModalComponent) {
                    this.urlShortenerModalComponent.openModal();
                }
                break;
            case EMBED:
                this.chartEmbedModalComponent.openModal();
                break;
            case TWEET:
                this.shareScatterPlot(SCATTER_PLOT_SHARING_URL_OPTIONS.TWITTER);
                break;
            case SHARE:
                if (!this.selectedFolderableInfo || !this.selectedItem)
                    break;
                const selectedFolderableItem = {
                    id: this.selectedItem.id,
                    name: this.selectedItem.name,
                    // The name of the backend Model
                    itemType: this.selectedFolderableInfo.resourceType,
                    // A human-readable description of the item type
                    itemTypeDescription: this.selectedFolderableInfo.resourceTypeDescription,
                    ancestorFolderId: this.selectedFolderableInfo.ancestorFolderId,
                    sharing: this.selectedItem.sharing,
                };
                this.store.dispatch(setSelectedFolderableOperation({
                    selectedOperation: {
                        item: selectedFolderableItem,
                        operation: SHARE,
                    },
                }));
                break;
            default:
                break;
        }
    }
    shareScatterPlot(sharingOption) {
        const left = window.screen.width / 2 - sharingOption.width / 2;
        const top = window.screen.height / 2 - sharingOption.height / 2;
        const windowProperties = `popup=1,width=${sharingOption.width},height=${sharingOption.height},screenX=${left},screenY=${top}`;
        // We need to open the window in response to the user click. Otherwise the popup window may be blocked.
        const newWindow = window.open('', '', windowProperties);
        this.scatterPlotService.getScatterPlotShareUrl(sharingOption.url, this.scatterPlotState).subscribe({
            next: (response) => {
                newWindow.location.href = response.redirectUrl;
            },
            error: (error) => {
                newWindow.close();
                throw error;
            },
        });
    }
    setErrorMessage(message) {
        if (message === '') {
            this.store.dispatch(clearPageErrorMessage());
        }
        else {
            this.store.dispatch(setPageErrorMessage({ message }));
        }
    }
}
ScatterPlotHeaderComponent.ɵfac = function ScatterPlotHeaderComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ScatterPlotHeaderComponent)(i0.ɵɵdirectiveInject(i1.ScatterPlotAppStateManager), i0.ɵɵdirectiveInject(i2.FeatureService), i0.ɵɵdirectiveInject(i3.SelectedScatterPlotService), i0.ɵɵdirectiveInject(i4.ScatterPlotService), i0.ɵɵdirectiveInject(i5.Store)); };
ScatterPlotHeaderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ScatterPlotHeaderComponent, selectors: [["ycn-scatter-plot-header"]], viewQuery: function ScatterPlotHeaderComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(UrlShortenerModalComponent, 5);
        i0.ɵɵviewQuery(_c1, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.featureNeededComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.urlShortenerModalComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartEmbedModalComponent = _t.first);
    } }, inputs: { securityPageType: "securityPageType" }, standalone: false, decls: 16, vars: 10, consts: [["chartEmbedModalComponent", ""], ["featureNeededComponent", ""], [1, "page-header", "row"], [1, "page-title", "col-5", "col-md-7"], [1, "page-header-actions"], [1, "page-header-action", "dropdown", 3, "handler", "buttonClass", "config", "inputDisabled", "dropdownClass"], [1, "page-header-action", "dropdown", 3, "handler", "buttonClass", "config", "dropdownClass"], [1, "page-header-action"], ["href", "javascript:void(0)", "data-test-id", "scatter-plot-reset-all", 1, "page-header-action-title", 3, "click"], ["ycnIcon", "", 3, "name"], [3, "embedCodeUrl"], [3, "publicSharingItemType", "shareableItem", 4, "ngIf"], [3, "publicSharingItemType", "shareableItem"]], template: function ScatterPlotHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
        i0.ɵɵelement(2, "ycn-scatter-plot-saved-item-dropdown");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 4)(4, "ycn-simple-dropdown", 5);
        i0.ɵɵlistener("handler", function ScatterPlotHeaderComponent_Template_ycn_simple_dropdown_handler_4_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.exportService.exportHandler($event, ctx.scatterPlotDataParams)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "ycn-simple-dropdown", 6);
        i0.ɵɵlistener("handler", function ScatterPlotHeaderComponent_Template_ycn_simple_dropdown_handler_5_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.sharingHandler($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 7)(7, "a", 8);
        i0.ɵɵlistener("click", function ScatterPlotHeaderComponent_Template_a_click_7_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.scatterPlotAppStateManager.resetToSystemDefault()); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(8, "svg", 9);
        i0.ɵɵtext(9, " Reset All ");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelement(10, "ycn-chart-embed-modal", 10, 0)(12, "ycn-url-shortener-modal");
        i0.ɵɵtemplate(13, ScatterPlotHeaderComponent_ycn_sharing_modal_13_Template, 1, 2, "ycn-sharing-modal", 11);
        i0.ɵɵelement(14, "ycn-feature-needed", null, 1);
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("buttonClass", "page-header-action-title")("config", ctx.EXPORT_OPTIONS)("inputDisabled", !ctx.chartHasValidExportData)("dropdownClass", "dropdown-menu-with-icons");
        i0.ɵɵadvance();
        i0.ɵɵproperty("buttonClass", "page-header-action-title")("config", ctx.sharingOptions)("dropdownClass", "dropdown-menu-with-icons");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("name", "icon-reset");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("embedCodeUrl", ctx.embedCodeUrl);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.selectedItem);
    } }, dependencies: [i6.NgIf, i7.ChartEmbedModalComponent, i8.FeatureNeededComponent, i9.IconDirective, i10.SharingModalComponent, i11.SimpleDropdownComponent, i12.UrlShortenerModalComponent, i13.ScatterPlotSavedItemDropdownComponent], encapsulation: 2 });
